import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

export default function Logo() {
  const { link, t } = useLang();
  return (
    <Link to={link("/")} data-testid="logo-link" className="flex items-center gap-3 shrink-0" aria-label="DIGITAL COMPANY">
      <img src="/favicon.svg" alt="" className="h-9 w-9" width="36" height="36" />
      <span className="leading-none">
        <span className="block font-display font-extrabold tracking-tight text-[15px] text-white">DIGITAL COMPANY</span>
        <span className="block text-[8.5px] tracking-[0.26em] text-steel mt-1.5">{t("brandLine")}</span>
      </span>
    </Link>
  );
}
